(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hs-wishlist"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('hs-wishlist');
  if (!dialog) return;
  const key = 'hotspot-wishlist-v1';
  const labels = dialog.dataset;
  const list = dialog.querySelector('[data-hs-wish-list]');
  const status = document.getElementById('hs-wish-status');
  let items = [];
  function read() {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(data) ? data.filter(p => p && typeof p.id === 'string' && typeof p.title === 'string' && typeof p.url === 'string' && p.url.startsWith('/') && !p.url.startsWith('//')).slice(0,200) : [];
    } catch { return []; }
  }
  function sync() {
    document.querySelectorAll('[data-hs-wish]').forEach(b => {
      const saved = items.some(p => p.id === b.dataset.hsWish);
      b.hidden = false;
      b.setAttribute('aria-pressed', String(saved));
      b.setAttribute('aria-label', (saved ? labels.remove : labels.add) + ': ' + b.dataset.title);
    });
    document.querySelectorAll('[data-hs-wish-open]').forEach(b => { b.hidden = false; });
    document.querySelectorAll('[data-hs-wish-count]').forEach(b => { b.textContent = String(items.length); b.hidden = !items.length; });
  }
  function render() {
    list.replaceChildren();
    dialog.querySelector('[data-hs-wish-empty]').hidden = items.length > 0;
    items.forEach(p => {
      const card = document.createElement('article');
      card.className = 'hs-wish-item';
      const link = document.createElement('a');
      link.href = p.url;
      link.setAttribute('aria-label', labels.view + ': ' + p.title);
      if (typeof p.image === 'string' && /^(https:\/\/|\/\/)/.test(p.image)) {
        const image = document.createElement('img');
        image.src = p.image; image.alt = p.title; image.loading = 'lazy';
        link.append(image);
      }
      const brand = document.createElement('strong'); brand.textContent = p.vendor || '';
      const title = document.createElement('p'); title.textContent = p.title;
      link.append(brand,title);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.dataset.hsWishRemove = p.id;
      remove.textContent = labels.remove;
      remove.setAttribute('aria-label', labels.remove + ': ' + p.title);
      card.append(link,remove); list.append(card);
    });
  }
  function save(next, message) {
    try { localStorage.setItem(key,JSON.stringify(next)); }
    catch {
      status.textContent = labels.error;
      dialog.querySelector('[data-hs-wish-error]').textContent = labels.error;
      return false;
    }
    items = next; sync(); status.textContent = message;
    dialog.querySelector('[data-hs-wish-error]').textContent = '';
    return true;
  }
  items = read(); sync();
  document.addEventListener('click',e => {
    const button = e.target.closest('[data-hs-wish],[data-hs-wish-open],[data-hs-wish-remove]');
    if (!button) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (button.hasAttribute('data-hs-wish-open')) { items = read(); sync(); render(); dialog.showModal(); return; }
    items = read();
    if (button.hasAttribute('data-hs-wish-remove')) {
      const id = button.dataset.hsWishRemove;
      const index = items.findIndex(p => p.id === id);
      if (save(items.filter(p => p.id !== id),labels.removed)) {
        render();
        const buttons = list.querySelectorAll('button');
        (buttons[Math.min(index,buttons.length-1)] || dialog.querySelector('.hs-wish-close')).focus();
      }
      return;
    }
    const id = button.dataset.hsWish;
    const exists = items.some(p => p.id === id);
    const next = exists ? items.filter(p => p.id !== id) : [...items,{id,title:button.dataset.title,vendor:button.dataset.vendor,url:button.dataset.url,image:button.dataset.image}];
    save(next,exists ? labels.removed : labels.added);
  },true);
  window.addEventListener('storage',e => { if(e.key === key || e.key === null) { items = read(); sync(); if(dialog.open) render(); } });
  window.addEventListener('pageshow',() => { items = read(); sync(); });
  new MutationObserver(records => {
    if(records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches('[data-hs-wish],[data-hs-wish-open]') || n.querySelector('[data-hs-wish],[data-hs-wish-open]'))))) sync();
  }).observe(document.body,{childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

})();
